// action - session data reducer
export const PERMISSIONS = '@session/PERMISSIONS';
export const SELECTED_CATEGORY = '@session/SELECTED_CATEGORY';
export const SELECTED_CATEGORY_ROW = '@session/SELECTED_CATEGORY_ROW';
